<template>
  <div class="container">
    <h1>Statistiques Client</h1>

    <div class="mt-4 d-flex justify-content-between align-items-end">
      <h4 class="text-secondary">Période de {{ responseDate }}</h4>

      <form class="form-inline w-auto" @submit.prevent="refreshList">
        <label class="sr-only" for="inlineFormInputName2">Date</label>
        <input
          type="month"
          class="form-control mb-2 mr-sm-2"
          id="date"
          v-model="date"
        />

        <button type="submit" class="btn btn-primary mb-2">Rechercher</button>
      </form>
    </div>

    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">Client</th>
          <th scope="col" class="text-center">Salles</th>
          <th scope="col" class="text-center">Sessions</th>
          <th scope="col" class="text-center">Joueurs</th>
          <!-- <th scope="col">&nbsp;</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-if="!list || list.length == 0">
          <td colspan="12" class="text-center py-4">Aucune donnée.</td>
        </tr>

        <tr v-for="(item, index) of list" :key="index">
          <td scope="row">
            <router-link :to="'/client/' + item._id">{{
              item.name
            }}</router-link>
          </td>
          <td class="text-center">{{ item.nbRooms }}</td>
          <td class="text-center">{{ item.nbSessions }}</td>
          <td class="text-center">{{ item.nbPlayers }}</td>
          <!-- <td class="text-nowrap">
                    <button type="button" class="btn btn-sm btn-primary" @click="refresh()">Rafraichir</button>
                </td> -->
        </tr>

        <tr class="font-weight-bold">
          <td class="pt-4">Total</td>
          <td class="pt-4 text-center">{{ total.nbRooms }}</td>
          <td class="pt-4 text-center">{{ total.nbSessions }}</td>
          <td class="pt-4 text-center">{{ total.nbPlayers }}</td>
        </tr>
      </tbody>
    </table>

    <h2 class="mt-5 text-black-50">Par jour</h2>
    <b-tabs class="mt-2">
      <b-tab v-for="(client, index) of list" :key="index" :title="client.name">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Date</th>
              <th scope="col" class="text-center">Sessions</th>
              <th scope="col" class="text-center">Joueurs</th>
              <!-- <th scope="col">&nbsp;</th> -->
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(day, dayIndex) in daysOfMonth"
              :key="`c_${index}_d_${dayIndex}`"
            >
              <td>{{ day }}</td>
              <td class="text-center">
                {{ getDailyStats(client._id, day).totalSessions }}
              </td>
              <td class="text-center">
                {{ getDailyStats(client._id, day).totalPlayers }}
              </td>
            </tr>

            <tr class="font-weight-bold">
              <td class="pt-4">Total</td>
              <td class="pt-4 text-center">
                {{ totalByClient[client._id].nbSessions }}
              </td>
              <td class="pt-4 text-center">
                {{ totalByClient[client._id].nbPlayers }}
              </td>
            </tr>
          </tbody>
        </table>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'

  export default {
    name: 'ClientStats',
    mounted() {
      this.refreshList()
    },
    data() {
      return {
        date: this.$route.query.date || moment().format('YYYY-MM'),
        responseDate: null,

        list: [],
      }
    },
    computed: {
      daysOfMonth() {
        // Return an array of days of the month
        return new Array(moment(this.date, 'YYYY-MM').daysInMonth(this.date))
          .fill(null)
          .map((x, i) =>
            moment(this.date)
              .startOf('month')
              .add(i, 'days')
              .format('DD/MM/YYYY')
          )
      },
      total() {
        return this.list.reduce(
          (acc, item) => {
            acc.nbRooms += item.nbRooms
            acc.nbSessions += item.nbSessions
            acc.nbPlayers += item.nbPlayers
            return acc
          },
          { nbRooms: 0, nbSessions: 0, nbPlayers: 0 }
        )
      },
      totalByClient() {
        return this.list.reduce((acc, item) => {
          acc[item._id] = {
            nbRooms: item.nbRooms,
            nbSessions: item.nbSessions,
            nbPlayers: item.nbPlayers,
          }
          return acc
        }, {})
      },
    },
    methods: {
      async refreshList() {
        try {
          let response = await axios.get('/api/un/stat/client', {
            params: {
              date: this.date,
              daily_stats: true,
            },
          })

          this.responseDate = moment(this.date, 'YYYY-MM').format('MM-YYYY')
          if (this.$route.query.date != this.date) {
            this.$router.push({ query: { date: this.date } })
          }

          this.list = response.data.sort((a, b) => {
            if (a.name < b.name) return -1
            if (a.name > b.name) return 1
            return 0
          })
        } catch (error) {
          this.$notify({
            type: 'error',
            title: 'Récupération des statistiques',
            text: error ? error : 'Erreur inconnue.',
          })
        }
      },
      getDailyStats(clientId, day) {
        const dayStr = moment(day, 'DD/MM/YYYY').format('YYYY-MM-DD')
        const client = this.list.find((c) => c._id == clientId)
        if (!client)
          return {
            totalSessions: 0,
            totalPlayers: 0,
          }

        console.log(client, dayStr, client.dailyStats[dayStr])

        const dayStats = client.dailyStats[dayStr] || {
          totalSessions: 0,
          totalPlayers: 0,
        }

        return {
          totalSessions: dayStats.totalSessions,
          totalPlayers: dayStats.totalPlayers,
        }
      },
    },
  }
</script>

<style scoped>
  .formContainer {
    width: 40%;
    margin-top: 2%;
  }
</style>
